import React from 'react';
import { View, StyleSheet } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import qrcode from 'qrcode-generator';
import { Palette } from '../theme/tokens';

interface QRCodeProps {
  value: string;
  size?: number;
  color?: string;
  backgroundColor?: string;
}

export const QRCode: React.FC<QRCodeProps> = ({
  value,
  size = 200,
  color = Palette.black,
  backgroundColor = Palette.white,
}) => {
  // Determine optimal version automatically based on input length
  const qr = qrcode(0, 'M');
  qr.addData(value);
  qr.make();

  const moduleCount = qr.getModuleCount();
  const cellSize = 1;
  const padding = 2; // Quiet zone boundary padding
  const viewPortSize = moduleCount + padding * 2;

  // Build a single SVG path string for all dark modules
  let pathData = '';
  for (let row = 0; row < moduleCount; row++) {
    for (let col = 0; col < moduleCount; col++) {
      if (qr.isDark(row, col)) {
        const x = col + padding;
        const y = row + padding;
        pathData += `M${x},${y}h${cellSize}v${cellSize}h-${cellSize}z `;
      }
    }
  }

  return (
    <View style={[styles.container, { width: size, height: size, backgroundColor }]}>
      <Svg
        width={size}
        height={size}
        viewBox={`0 0 ${viewPortSize} ${viewPortSize}`}
      >
        <Path d={pathData} fill={color} />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderRadius: 8,
    alignSelf: 'center',
  },
});
